import React from 'react';

import { IconButton, IconButtonProps } from '@rbilabs/universal-components';

type StoreCardButtonProps = Pick<
  IconButtonProps,
  'accessibilityLabel' | 'icon' | 'onPress' | 'testID' | 'isDisabled'
>;

export const StoreCardButton = ({
  accessibilityLabel,
  onPress,
  icon,
  testID,
  isDisabled,
}: StoreCardButtonProps) => {
  return (
    <IconButton
      variant="ghost"
      accessibilityLabel={accessibilityLabel}
      onPress={onPress}
      icon={icon}
      testID={testID}
      isDisabled={isDisabled}
      padding="$1"
    />
  );
};
